// extracted by mini-css-extract-plugin
export var csatScore = "_ll-5";
export var header = "_ll-1";
export var panelWrapper = "_ll-2";
export var postPreview = "_ll-3";
export var rightContent = "_ll-0";
export var wrappingText = "_ll-4";